import env from '~/libs/env'

export default {
  /**
   * POST a collected SEON session to the API. The auth token is auto-attached
   * by the axios request interceptor. Returns the axios promise; callers should
   * treat this as fire-and-forget and catch errors themselves.
   */
  storeSession({ borrowerId, contactId = null, session, $axios }) {
    return $axios.post(
      `${env('apiUrl')}/borrower-portal/borrower/${borrowerId}/seon-session`,
      { session, contactId: contactId ?? null },
    )
  },
}
